import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
    size?: number;
}

const SearchIcon = ({ size = 15, ...props }: Props) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 13 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.78243 1.14571e-05C4.86029 9.00181e-05 3.95153 0.220691 3.13199 0.643408C2.31244 1.06613 1.60586 1.6787 1.07121 2.43003C0.536557 3.18136 0.189331 4.04965 0.0584995 4.96247C-0.0723317 5.87528 0.0170265 6.80615 0.319119 7.67741C0.621211 8.54866 1.12728 9.33504 1.7951 9.97094C2.46292 10.6068 3.27312 11.0738 4.15812 11.3329C5.04312 11.592 5.97724 11.6357 6.88256 11.4603C7.78788 11.285 8.63814 10.8957 9.3624 10.3249L11.847 12.8095C11.9753 12.9335 12.1472 13.002 12.3256 13.0005C12.504 12.9989 12.6746 12.9274 12.8007 12.8012C12.9269 12.6751 12.9984 12.5045 13 12.3261C13.0015 12.1477 12.933 11.9758 12.809 11.8475L10.3244 9.3629C10.9966 8.51017 11.4151 7.48543 11.5321 6.40594C11.6491 5.32646 11.4598 4.23585 10.9859 3.25892C10.5119 2.282 9.77257 1.45823 8.85235 0.881894C7.93212 0.305558 6.86823 -6.14502e-05 5.78243 1.14571e-05ZM1.3602 5.78293C1.3602 4.61008 1.82611 3.48527 2.65544 2.65594C3.48477 1.82661 4.60958 1.3607 5.78243 1.3607C6.95528 1.3607 8.08009 1.82661 8.90942 2.65594C9.73875 3.48527 10.2047 4.61008 10.2047 5.78293C10.2047 6.95578 9.73875 8.0806 8.90942 8.90993C8.08009 9.73925 6.95528 10.2052 5.78243 10.2052C4.60958 10.2052 3.48477 9.73925 2.65544 8.90993C1.82611 8.0806 1.3602 6.95578 1.3602 5.78293Z"
            fill={props.color || "currentColor"}
        />
    </svg>
);
export default SearchIcon;
